import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TProductCart, adaptProductCartFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_PRODUCT_CART } from '../../backend-paths';


export const accountProductCartDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ACCOUNT_PRODUCT_CART}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ACCOUNT_PRODUCT_CART}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptProductCartFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProductCart> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountProductCartDeleteSlice = createSlice({
	name: 'accountProductCartDeleteSlice',
	initialState,
	reducers: {
		clearAccountProductCartDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProductCartDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProductCartDeleteApi.fulfilled.type]: (state, action: PayloadAction<TProductCart>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountProductCartDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProductCartDeleteSelector = () => useAppSelector(state => state[accountProductCartDeleteSlice.name]);

export const { clearAccountProductCartDelete } = accountProductCartDeleteSlice.actions;
